import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { Snackbar, Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const location = useLocation();
    const auth = getAuth();
    const user = auth.currentUser;

    useEffect(() => {
        const auth = getAuth();
        // Every Auth State runs twice, debug and fix this ...
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            console.log("PR : User", user);
            if (user !== null) {
                try {
                    // Query Firestore to check for admin access
                    const usersRef = collection(db, 'users');
                    const q = query(usersRef, where('email', '==', user.email), where('isAdmin', '==', true));
                    const querySnapshot = await getDocs(q); // Use await here

                    if (!querySnapshot.empty || user.email === 'autoseo.notifications@gmail.com') {
                        setIsAuthorized(true);
                    } else {
                        throw new Error('Access denied: You are not authorized to access this application.');
                    }
                } catch (error) {
                    console.error('Error checking admin access:', error);
                    setSnackbarMessage(error.message);
                    setSnackbarOpen(true);
                    // Sign out unauthorized user
                    await signOut(auth).catch((error) => {
                        console.error('Error signing out:', error);
                    });
                    setIsAuthorized(false);
                }
            }
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }

    if (!isAuthorized) {
        return <Navigate to="/" state={{ snackbarMessage }} replace />;
    }

    return (
        <>
            {children}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={15000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={handleSnackbarClose}
            >
                <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ProtectedRoute;
